<!-- The sidebar -->
<!-- <div class="sidebar border"  >
    <div class="clear10"></div>
    <div class="menu outline-0 cp" routerLink="/dashboard"><img src="./assets/images/inner-logo.png" /></div>
    <div class="clear40"></div>
    <a><img src="./assets/images/dashboard.png"class="fs-18 mr-3"/>Dashboard</a>
 </div> -->


 <div class="col-12 col-sm-12 col-md-12 col-lg-12 boxstyle">
    <!-- <div class="col-12 col-sm-12 col-md-12 col-lg-12">
        <div class="row">
            <div class="topbox mr18 col-12 col-sm-1 col-md-1 col-lg-1" *ngFor="let item of stage; let i=index">
                <div class="text-center">
                    <label class="semi-bold fs-24 m-0 text-center">{{item.count}}<span class="percentagetxt fs-16 semi-bold">  ({{item.percentage}})</span></label>
                    <div class="clear"></div>
                    <label *ngIf="i==0" class="fs-14 regular green m-0 text-center cp" (click)="test(item.name)">{{(item.displayName.length>10)? ( item.displayName | slice:0:10)+'...':( item.displayName)}}</label>
                    <label *ngIf="i==1" class="fs-14 regular regular lightblue m-0 text-center cp" (click)="test(item.name)">{{(item.displayName.length>10)? ( item.displayName | slice:0:10)+'...':( item.displayName)}}</label>
                    <label *ngIf="i==2" class="fs-14 regular regular orange m-0 text-center cp" (click)="test(item.name)">{{(item.displayName.length>10)? ( item.displayName | slice:0:10)+'...':( item.displayName)}}</label>
                    <label *ngIf="i==3" class="fs-14 regular darkblue m-0 text-center cp" (click)="test(item.name)">{{(item.displayName.length>10)? ( item.displayName | slice:0:10)+'...':( item.displayName)}}</label>
                    <label *ngIf="i==4" class="fs-14 regular green m-0 text-center cp" (click)="test(item.name)">{{(item.displayName.length>10)? ( item.displayName | slice:0:10)+'...':( item.displayName)}}</label>
                    <label *ngIf="i==5" class="fs-14 fs-14 regular purple m-0 text-center borderright cp" (click)="test(item.name)">{{(item.displayName.length>10)? ( item.displayName | slice:0:10)+'...':( item.displayName)}}</label>
                    <label *ngIf="i==6" class="fs-14 regular green m-0 text-center cp" (click)="test(item.name)">{{(item.displayName.length>10)? ( item.displayName | slice:0:10)+'...':( item.displayName)}}</label>
                    <label *ngIf="i==7" class="fs-14 fs-14 regular purple m-0 text-center borderright cp" (click)="test(item.name)">{{(item.displayName.length>10)? ( item.displayName | slice:0:10)+'...':( item.displayName)}}</label>
                    <div class="clear5"></div>
                    <div class="clear20"></div>
                </div>
            </div>
        </div>
    </div> -->
    <div class="row">
        <div class="col-7 col-sm-7 col-md-7 col-lg-7 text-center">
            <div class="row">
                <div class="topbox" [ngClass]="{'activeone': i==sub}" *ngFor="let item of stage; let i=index">
                    <div class="">
                        <label class="semi-bold fs-24 m-0">{{item.count}}</label><br>
                        <span class="percentagetxt fs-16 semi-bold" [ngClass]="{'activeone': i==sub}">  ({{item.percentage}})</span>
                        <div class="clear"></div>
                        <label *ngIf="i==0" class="fs-14 regular orange m-0 cp" title="{{item.displayName}}" [ngClass]="{'activeone': i==sub}" (click)="test(item.name,i)">{{(item.displayName.length>20)? ( item.displayName | slice:0:20)+'...':( item.displayName)}}</label>
                        <label *ngIf="i==1" class="fs-14 regular green m-0 cp" title="{{item.displayName}}" [ngClass]="{'activeone': i==sub}" (click)="test(item.name,i)">{{(item.displayName.length>20)? ( item.displayName | slice:0:20)+'...':( item.displayName)}}</label>
                        <label *ngIf="i==2" class="fs-14 regular orange m-0 cp" title="{{item.displayName}}" [ngClass]="{'activeone': i==sub}" (click)="test(item.name,i)">{{(item.displayName.length>20)? ( item.displayName | slice:0:20)+'...':( item.displayName)}}</label>
                        <label *ngIf="i==3" class="fs-14 regular green m-0 cp" title="{{item.displayName}}" [ngClass]="{'activeone': i==sub}" (click)="test(item.name,i)">{{(item.displayName.length>20)? ( item.displayName | slice:0:20)+'...':( item.displayName)}}</label>
                        <label *ngIf="i==4" class="fs-14 regular orange m-0 cp" title="{{item.displayName}}" [ngClass]="{'activeone': i==sub}" (click)="test(item.name,i)">{{(item.displayName.length>10)? ( item.displayName | slice:0:10)+'...':( item.displayName)}}</label>
                        <label *ngIf="i==5" class="fs-14 regular green m-0 cp" title="{{item.displayName}}" [ngClass]="{'activeone': i==sub}" (click)="test(item.name,i)">{{(item.displayName.length>9)? ( item.displayName | slice:0:9)+'...':( item.displayName)}}</label>
                        <label *ngIf="i==6" class="fs-14 regular green m-0 cp" title="{{item.displayName}}" [ngClass]="{'activeone': i==sub}" (click)="test(item.name,i)">{{(item.displayName.length>10)? ( item.displayName | slice:0:10)+'...':( item.displayName)}}</label>
                        <label *ngIf="i==7" class="fs-14 regular green m-0 cp" title="{{item.displayName}}" [ngClass]="{'activeone': i==sub}" (click)="test(item.name,i)">{{(item.displayName.length>9)? ( item.displayName | slice:0:9)+'...':( item.displayName)}}</label>
                        <label *ngIf="i==8" class="fs-14 regular green m-0 cp" title="{{item.displayName}}" [ngClass]="{'activeone': i==sub}" (click)="test(item.name,i)">{{(item.displayName.length>10)? ( item.displayName | slice:0:10)+'...':( item.displayName)}}</label>
                        <label *ngIf="i==9" class="fs-14 regular green m-0 cp" title="{{item.displayName}}" [ngClass]="{'activeone': i==sub}" (click)="test(item.name,i)">{{(item.displayName.length>10)? ( item.displayName | slice:0:10)+'...':( item.displayName)}}</label>
                        <label *ngIf="i==10" class="fs-14 regular green m-0 cp" title="{{item.displayName}}" [ngClass]="{'activeone': i==sub}" (click)="test(item.name,i)">{{(item.displayName.length>10)? ( item.displayName | slice:0:10)+'...':( item.displayName)}}</label>
                        <div class="clear5"></div>
                        <div class="clear20"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-5 col-sm-5 col-md-5 col-lg-5">
          <div class="topbox2">
              <label class="fs-16 green semi-bold">Compliance</label>
              <div class="row">
                  <div class="col-lg-4">
                    <div class="row">
                        <div class="col-lg-12">
                            <label class="text46 semi-bold mr-1">Documents</label>
                            <label class="switch2">
                                <input type="checkbox"  value="false" [checked]="showexpDocColumns" (click)="expdocumentsToggle($event)">
                                <span class="slider1 round1"></span>
                            </label>
                        </div>   
                        <!-- <div class="col-lg-4">
                           
                        </div>       -->
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div class="row">
                        <div class="col-lg-12">
                            <label class="text46 semi-bold mr-1">Deactivated</label>
                            <label class="switch2">
                                <input type="checkbox"  value="false" [checked]="showDeactivationColumns" (click)="deactivateddocumentsToggle($event)">
                                <span class="slider1 round1"></span>
                            </label>
                        </div>   
                        <!-- <div class="col-lg-4">
                          
                        </div>       -->
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="row">
                        <div class="col-lg-12">
                            <label class="text46 semi-bold mr-1">More Info Req</label>
                            <label class="switch2">
                                <input type="checkbox"  value="false" [checked]="moreInfoReqiredColumns" (click)="moreInfoReqiredToggle($event)">
                                <span class="slider1 round1"></span>
                            </label>
                        </div>   
                        <!-- <div class="col-lg-4">
                        
                        </div>       -->
                    </div>
                </div>
              </div>
          </div>
        </div>
    </div>
    
    <div class="clear20"></div>
    <label [hidden]="agentcodedata.length==0" class="fs-16 txt-black regular">Click on the Agency Code below to enter the sales portal.
        <span class="tooltip1">
            <img src="./assets/images/iIconblue.svg">
            <div class="tooltiptext1 regular fs-14">
            <span class="whitespacenormal italic">If you have more than one agency code, select the agency code from which you would like to access the sales portal.</span>
            </div>
        </span>
    </label>
    <div class="clear10"></div>
    <div class="row" [hidden]="agentcodedata.length==0">
        <div class="mr-2" [hidden]="item.agentCode == null" *ngFor="let item of agentcodedata; let i=index">
            <button type="button"  *ngIf="(item.status=='Active' || item.status=='Primary')" class="agentcodebtn olnone regular cp" [title]="item.agencyName" (click)="toggleadd(item.agentCode,i,item.id,item.agentId,item.status)" [ngClass]="{'op5':leadStatus == 'Deactivated', 'activeoneagentCode': i==subAgent }">{{item.agentCode}}</button>
            <button type="button"  *ngIf="(item.status!=='Active' && item.status!=='Primary')" class="agentcodebtn olnone regular cp" [title]="item.agencyName" (click)="toggleadd(item.agentCode,i,item.id,item.agentId,item.status)" [ngClass]="{'op5': item.status !== 'Active' && item.status !== 'Primary' && leadStatus=='Deactivated', 'activeoneagentCode': i === subAgent }">{{item.agentCode}}</button>
        </div>
    </div>
   
    <div class="clear10"></div>
    <div class="row whitebox">
        <div class="col-9 col-sm-9 col-md-9 col-lg-9">
            <div class="row">
                <button type="button" (click)=" this.filterModal = !this.filterModal;" class=" fs-14 regular filterbtn">Filters &nbsp;<img src="./assets/images/popupIcon.png"> </button>
                <span class="fs-14 regular leads ml-2 mt-1" *ngIf="showdate">Date:&nbsp;{{fromDate1}}&nbsp;to&nbsp;{{toDate1}}&nbsp;&nbsp;</span>
                <!-- <span class="fs-14 regular" *ngFor="let item of stageStatus">{{item}}&nbsp;</span> -->
                <span class="fs-14 regular leads mt-1 ml-1" *ngIf="!showActivatedTable">&nbsp;Brokers&nbsp;({{total}})&nbsp;</span>
                <span class="fs-14 regular leads mt-1 ml-1" *ngIf="showActivatedTable && !showDeactivationColumns">&nbsp;Documents&nbsp;({{totalActivate}})&nbsp;</span>
                <span class="fs-14 regular leads mt-1 ml-1" *ngIf="showActivatedTable && showDeactivationColumns">&nbsp;Broker&nbsp;({{totalActivate}})&nbsp;</span>
                <span class="fs-14 regular mt-1 ml-1">&nbsp;Showing&nbsp;&nbsp;</span>
                <select class="form-control selectinput displead mt-1" [(ngModel)]="onSelectSizePage" (click)="onSelectSize()">
                <!-- <option selected disabled>Select province</option> -->
                <option disabled hidden value="undefined">30</option>
                <option value="15">15</option>
                 <option value="30">30</option>
                 <option value="45">45</option>
                 <option value="60">60</option>
                 <option value="100">100</option>
            </select>
                <img (click)="refreshPage()" src="./assets/images/refresh.png" class="cp disin ml-2" style="padding: 7px;" data-toggle="tooltip" title="Refresh">
                <!-- <span *ngIf="!showActivatedTable" class="fs-14 regular mt-1">&nbsp;&nbsp;Total Number of Brokers:&nbsp;&nbsp;({{total}})</span> -->
                <!-- <span *ngIf="showActivatedTable" class="fs-14 regular mt-1">&nbsp;&nbsp;Total Number of Brokers:&nbsp;&nbsp;({{totalActivate}})</span> -->

            </div>
        </div>
        <div class="col-1 col-sm-1 col-md-1 col-lg-1 pr-2">
            
            <button *ngIf="isDeactivateButton" type="button" class=" fs-14 regular exportbtn" (click)="deActivateLead()">Deactivate</button>
        </div>
        <div class="col-1 col-sm-1 col-md-1 col-lg-1 pr-2">
            <button *ngIf="showExport" type="button" class=" fs-14 regular exportbtn" (click)="exportLead()">Export &nbsp;<img src="./assets/images/exporticon.png"> </button>
            
        </div>
        <div class="col-1 col-sm-1 col-md-1 col-lg-1">
<button type="button" *ngIf="(leadType=='Travel Agency Rep' || leadType=='General Agency Rep')" class=" fs-14 regular addAgentBtn" (click)="onClickAddAgent()">+ Add Agent</button>
        </div>
    </div>
    <div class="clear10"></div>
    <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12 text-left" *ngIf="showexpDocColumns">
        <div class="expDoccardbox">
            <label class="text46 italic fs-14"><span class="semi-bold italic">Listed below are documents that will expire within the next 30 days or have already expired.</span> Ensure each document listed below is up-to-date to avoid interruption to your broker's access to sell.<br>
                <span class="semi-bold italic">To update the documents:</span> upload a document on a broker’s behalf, or have the broker log into their MyTL account, go to ‘Account’ then ‘Documents’, then click ‘Update’ and follow the instructions.<br>
                <span class="semi-bold italic">Only ‘Update’ an existing license with a current copy of that license.</span> For example, do not use the ‘Update’ function to upload a Manitoba license to an existing Alberta license. To upload a new license, use the ‘+Add License’ option.</label>
        </div>
    </div>
    <div class="row">
        <div class="fs-14 regular col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
            <div *ngIf="showFilter">
                <span class="red italic" [hidden]="stageShow.length==0">Filters Applied:&nbsp;&nbsp;</span> 
                <span class="italic" *ngFor=" let item of stageShow;let isLast=last">{{item}}{{isLast ? '' : ', '}}</span>
                <h6 class="close text-right" [hidden]="stageShow.length==0" (click)="closeFilter();refreshPage()">&times;</h6>
            </div>
            <span *ngIf="selectedId.length>0 && selectallRecords">You have selected {{selectedId.length}} record(s) in this view.<a class="cp" (click)="selectAllRecords()">&nbsp;Select all records</a>&nbsp;in the result set.</span>
            <span *ngIf="total>0 && clearSelection && !showActivatedTable">You have selected all {{total}} records in the result set.<a class="cp" (click)="clearAllRecords()">&nbsp;Clear selections.</a></span>
            <span *ngIf="totalActivate>0 && clearSelection && showActivatedTable && !showDeactivationColumns">You have selected all {{totalActivate}} records in the result set.<a class="cp" (click)="clearAllRecords()">&nbsp;Clear selections.</a></span>
            <span *ngIf="totalActivate>0 && clearSelection && showActivatedTable && showDeactivationColumns">You have selected all {{totalActivate}} records in the result set.<a class="cp" (click)="clearAllRecords()">&nbsp;Clear selections.</a></span>

        </div>
        <span class="fs-16 mt-1 regular col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12 text-right">Search:&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <input type="text" class="searchstyle fs-14 regular col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 Tab" placeholder="By email, first name, last name" (input)="searchMgaData(serachMga)" [(ngModel)]="serachMga">
        <!-- <input *ngIf="!moreInfoReqiredColumns && showActivatedTable && !showDeactivationColumns" type="text" class="searchstyle fs-14 regular col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 Tab" placeholder="By email, first name, last name, phone no…" (input)="searchMgaDataDocuments(serachMga1)" [(ngModel)]="serachMga1">
        <input *ngIf="!moreInfoReqiredColumns && showActivatedTable && showDeactivationColumns" type="text" class="searchstyle fs-14 regular col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 Tab" placeholder="By email, first name, last name, phone no…" (input)="searchMgaDataDocuments(serachMga2)" [(ngModel)]="serachMga2">
        <input *ngIf="moreInfoReqiredColumns && showActivatedTable && !showDeactivationColumns" type="text" class="searchstyle fs-14 regular col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 Tab" placeholder="By email, first name, last name, phone no…" (input)="searchMgaDataMoreInfoReq(serachMga3)" [(ngModel)]="serachMga3"> -->
        <!-- <div *ngIf="searchPopup" class="searchResultBox">
            <div class="borderbottom">
              <label class="fs-12 regular text98 m-0 p-2">SEARCH RESULTS FOR: {{serachMga}} Total Count: ({{globalSearchCount}})</label>
            </div>
            <div class="row borderbottom p-1" *ngFor="let item of globalSearchData">
              <div class="col-2 col-sm-2 col-md-2 col-lg-2 text-center">
                <img class="img-fluid searchlisticon cp" title="Leads" src="./assets/images/Lead.png">
              </div>
              <div class="col-10 col-sm-10 col-md-10 col-lg-10">
                <label class="fs-14 regular m-0 link cp" routerLink="/dashboard/mga-details" (click)="onClickMga($event,item.leadId,item.mga.id)">{{item.name}}</label><br>
                <label class="fs-14 regular text46 m-0">{{item.stage}}</label><br>
              </div>
            </div>
          </div> -->

    </div>
    <div id="filters" class="modal" [style.display]="filterModal ? 'block' : 'none'">
        <!-- Modal content -->
        <div class="modal-dialog filter-dialog">
            <div class="modal-content w-100">
                <div class="modal-header">
                    <span class="fs-18 text46 semi-bold">Filters</span>
                    <h6 class="close text-right" (click)=" this.filterModal = !this.filterModal">&times;</h6>
                </div>
                <div class="modal-body">

                    <div class="row">
                        <div class="col-sm-5 col-md-6 col-lg-6 col-12 mr-5">
                            <div class="form-group">
                                <label class="regular fs-14 text46">Stage</label>
                                <div class="multiselectdropdown">
                                    <angular2-multiselect name="dropdown-{{id}}" [data]="stagesArray" [(ngModel)]="stageStatusTest" [settings]="dropdownSettingsStage" (onSelect)="onItemSelectStage($event)" (onDeSelect)="OnItemDeSelectStage($event)" (onSelectAll)="onSelectAllStage($event)"
                                        (onDeSelectAll)="onDeSelectAllStage($event)"></angular2-multiselect>

                                </div>

                            </div>
                        </div>
                        <div class="col-sm-5 col-md-5 col-lg-5 col-12 ">
                            <!-- <div class="form-group">
                                <label class="regular fs-14 text46">Commission Type</label>
                            
                                <select [(ngModel)]="commitionType" class="form-control forminput">
                            <option>Select</option>
                                 
                          <option *ngFor="let item of commitionTypeArray">{{item.displayName}}</option>
                          </select>
                            </div> -->
                            <div class="form-group">
                                <label class="regular fs-14 text46">Date Created Range</label>
                                <input class="form-control forminput" [(ngModel)]="fromDateTest" [owlDateTimeTrigger]="dt1" [owlDateTime]="dt1" [selectMode]="'range'" placeholder="DD/MM/YYYY-DD/MM/YYYY">
                                <owl-date-time #dt1></owl-date-time>

                            </div>
                        </div>
                    </div>
                    <div class="clear20"></div>
                    <!-- <div class="row">
                        <div class="col-sm-5 col-md-5 col-lg-5 col-12 mr-5">
                            <div class="form-group">
                                <label class="regular fs-14 text46">Broker Type</label>
                                <select [(ngModel)]="brokerType" class="form-control forminput">
                                    <option>Select</option>
                               
                                   <option *ngFor="let item of leadTypesArray">{{item}}</option>
                                 </select>
                            </div>
                        </div>
                        <div class="col-sm-5 col-md-5 col-lg-5 col-12"> -->
                    <!-- <div class="form-group">
                                <label class="regular fs-14 text46">Date Created Range</label>
                                <input class="form-control forminput" [(ngModel)]="fromDateTest" [owlDateTimeTrigger]="dt1" [owlDateTime]="dt1" [selectMode]="'range'" placeholder="DD/MM/YYYY-DD/MM/YYYY">
                                <owl-date-time #dt1></owl-date-time>

                            </div> -->
                    <!-- </div>
                    </div> -->
                    <div class="clear20"></div>
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div class="row">
                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 text-right">
                                <button type="button" class=" fs-14 Regular addbtn mr-4" (click)="postFilter()">Apply</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="clear20"></div>
    </div>
    <div class="clear10"></div>
    <div class="row" *ngIf="!showActivatedTable">
        <div class="table-responsive">
            <!-- Toggle column: <a class="toggle-vis" data-column="1">First Name</a> - <a class="toggle-vis" data-column="2">Last Name</a> - <a class="toggle-vis" data-column="3">Stage</a> - <a class="toggle-vis" data-column="4">Type</a> - <a class="toggle-vis" data-column="5">Phone No</a> - <a class="toggle-vis" data-column="6">Provinces</a>- <a class="toggle-vis" data-column="7">City </a> -->
            <!-- <div class="dataTables_length" id="agency-table_length"><label>Show <select name="agency-table_length" aria-controls="agency-table" class=""><option value="10">10</option><option value="25">25</option><option value="50">50</option><option value="100">100</option></select> entries</label></div> -->
            <table id="lead-table" class="display table tablepos">

                <thead class="nowrap">
                    <tr>
                        <th>
                            <label class="container pb10">
                       <input type="checkbox" class="form-check-input"  [checked]="selectAllCheckbox==true" value = true (change)="toggleShow($event)">
                       <span class="checkmark"></span>
                      </label>
                        </th>
                        <th [hidden]="showName==false">
                            <div class="d-flex flex-row align-items-center">
                            <span>First Name</span>
                            <div class="d-flex flex-column ml-2">
                                <i class="fa fa-caret-up" (click)="onSort('firstName')"></i>
                                <i class="fa fa-caret-down" (click)="onSortdesc('firstName')"></i>
                            </div>
                        </div></th>
                        <th [hidden]="showLastName==false">
                            <div class="d-flex flex-row align-items-center">
                                <span>Last Name</span>
                                <div class="d-flex flex-column ml-2">
                                    <i class="fa fa-caret-up" (click)="onSort('lastName')"></i>
                                    <i class="fa fa-caret-down" (click)="onSortdesc('lastName')"></i>
                                </div>
                            </div>
                        </th>
                        <th [hidden]="showStage==false">
                            <div class="d-flex flex-row align-items-center">
                                <span>Stage</span>
                                <div class="d-flex flex-column ml-2">
                                    <i class="fa fa-caret-up" (click)="onSort('leadStatusStage')"></i>
                                    <i class="fa fa-caret-down" (click)="onSortdesc('leadStatusStage')"></i>
                                </div>
                            </div>
                        </th>
                        <th [hidden]="showType==false">
                            <div class="d-flex flex-row align-items-center">
                                <span>Type</span>
                                <div class="d-flex flex-column ml-2">
                                    <i class="fa fa-caret-up" (click)="onSort('type')"></i>
                                    <i class="fa fa-caret-down" (click)="onSortdesc('type')"></i>
                                </div>
                            </div>
                        </th>
                        <th [hidden]="showPhone==false">
                            <div class="d-flex flex-row align-items-center">
                                <span>Phone No</span>
                                <div class="d-flex flex-column ml-2">
                                    <i class="fa fa-caret-up" (click)="onSort('workPhone')"></i>
                                    <i class="fa fa-caret-down" (click)="onSortdesc('workPhone')"></i>
                                </div>
                            </div>
                        </th>
                        <th [hidden]="showProvinces==false">
                            <div class="d-flex flex-row align-items-center">
                                <span>Province</span>
                                <div class="d-flex flex-column ml-2">
                                    <i class="fa fa-caret-up" (click)="onSort('primaryAddressProvince')"></i>
                                    <i class="fa fa-caret-down" (click)="onSortdesc('primaryAddressProvince')"></i>
                                </div>
                            </div>
                        </th>
                        <th [hidden]="showCity==false">
                            <div class="d-flex flex-row align-items-center">
                                <span>City</span>
                                <div class="d-flex flex-column ml-2">
                                    <i class="fa fa-caret-up" (click)="onSort('primaryAddressCity')"></i>
                                    <i class="fa fa-caret-down" (click)="onSortdesc('primaryAddressCity')"></i>
                                </div>
                            </div>
                        </th>
                        <th [hidden]="showEmail==false">
                                <div class="d-flex flex-row align-items-center">
                                    <span>Email Address</span>
                                    <div class="d-flex flex-column ml-2">
                                        <i class="fa fa-caret-up" (click)="onSort('leadEmail')"></i>
                                        <i class="fa fa-caret-down" (click)="onSortdesc('leadEmail')"></i>
                                    </div>
                                </div>
                        </th>
                        <th [hidden]="showLanguages==false">
                            <div class="d-flex flex-row align-items-center">
                                <span>Languages</span>
                                <div class="d-flex flex-column ml-2">
                                    <i class="fa fa-caret-up" (click)="onSort('langauges')"></i>
                                    <i class="fa fa-caret-down" (click)="onSortdesc('langauges')"></i>
                                </div>
                            </div>
                        </th>
                        <th [hidden]="showStatus==false">
                            <div class="d-flex flex-row align-items-center">
                                <span>Lead Status</span>
                                <div class="d-flex flex-column ml-2">
                                    <i class="fa fa-caret-up" (click)="onSort('leadStatus')"></i>
                                    <i class="fa fa-caret-down" (click)="onSortdesc('leadStatus')"></i>
                                </div>
                            </div>
                        </th>
                        <th [hidden]="showSource==false">
                            <div class="d-flex flex-row align-items-center">
                                <span>Lead Source</span>
                                <div class="d-flex flex-column ml-2">
                                    <i class="fa fa-caret-up" (click)="onSort('leadSource')"></i>
                                    <i class="fa fa-caret-down" (click)="onSortdesc('leadSource')"></i>
                                </div>
                            </div>
                        </th>
                        <th [hidden]="showAddress==false">
                            <div class="d-flex flex-row align-items-center">
                                <span>Primary Address</span>
                                <div class="d-flex flex-column ml-2">
                                    <i class="fa fa-caret-up" (click)="onSort('primaryAddressLine')"></i>
                                    <i class="fa fa-caret-down" (click)="onSortdesc('primaryAddressLine')"></i>
                                </div>
                            </div>
                        </th>
                        <th [hidden]="showPostal==false">
                            <div class="d-flex flex-row align-items-center">
                                <span>Postal Address</span>
                                <div class="d-flex flex-column ml-2">
                                    <i class="fa fa-caret-up" (click)="onSort('primaryAddressPostalCode')"></i>
                                    <i class="fa fa-caret-down" (click)="onSortdesc('primaryAddressPostalCode')"></i>
                                </div>
                            </div>
                        </th>
                        <th [hidden]="showCountry==false">
                            <div class="d-flex flex-row align-items-center">
                                <span>Primary Country</span>
                                <div class="d-flex flex-column ml-2">
                                    <i class="fa fa-caret-up" (click)="onSort('primaryAddressPostalCode')"></i>
                                    <i class="fa fa-caret-down" (click)="onSortdesc('primaryAddressPostalCode')"></i>
                                </div>
                            </div>
                        </th>
                        <th [hidden]="showSelling==false">
                            <div class="d-flex flex-row align-items-center">
                                <span>Product Selling</span>
                                <div class="d-flex flex-column ml-2">
                                    <i class="fa fa-caret-up" (click)="onSort('productsSelling')"></i>
                                    <i class="fa fa-caret-down" (click)="onSortdesc('productsSelling')"></i>
                                </div>
                            </div>
                        </th>
                        <th [hidden]="showTitle==false">
                            <div class="d-flex flex-row align-items-center">
                                <span>Position Title</span>
                                <div class="d-flex flex-column ml-2">
                                    <i class="fa fa-caret-up" (click)="onSort('positionTitle')"></i>
                                    <i class="fa fa-caret-down" (click)="onSortdesc('positionTitle')"></i>
                                </div>
                            </div>
                        </th>
                        <th [hidden]="showLastTrainingDate==false">
                            <div class="d-flex flex-row align-items-center">
                                <span>Last Training Date</span>
                                <div class="d-flex flex-column ml-2">
                                    <i class="fa fa-caret-up" (click)="onSort('ciprNumber')"></i>
                                    <i class="fa fa-caret-down" (click)="onSortdesc('ciprNumber')"></i>
                                </div>
                            </div>
                        </th>
                        <!-- <th *ngIf="showexpDocColumns || showDeactivationColumns">
                            <label *ngIf="showexpDocColumns" class="tooltip1 mb-0"><img src="./assets/images/iIconblue.svg">Document
                            <div class="tooltiptext1 regular fs-14">
                                <span class="whitespacenormal italic tooltiptext2">Click on the link in the column below to review the broker's document and profile.</span>
                            </div>   
                            </label>
                            <label *ngIf="showDeactivationColumns" class="mb-0">Reason for Deactivation</label>                    
                        </th> -->
                        <th *ngIf="showexpDocColumns || showDeactivationColumns">
                            <label *ngIf="showexpDocColumns" class="tooltip1 mb-0"><img src="./assets/images/iIconblue.svg">Expiry Date
                                <div class="tooltiptext1 regular fs-14">
                                    <span class="whitespacenormal italic tooltiptext2">Yellow indicates the document will expire within 30 days. Red indicates the document has expired.</span>
                                </div>   
                            </label>
                            <label *ngIf="showDeactivationColumns" class="tooltip1 mb-0"><img src="./assets/images/iIconblue.svg">Date Deactivated
                                <div class="tooltiptext1 regular fs-14">
                                    <span class="whitespacenormal italic tooltiptext2">This is the date the broker was deactivated for sales in all provinces.</span>
                                </div>   
                            </label>
                        </th>
                        <th *ngIf="showDeactivationColumns || showexpDocColumns">
                            <label *ngIf="showexpDocColumns" class="tooltip1 mb-0"><img src="./assets/images/iIconblue.svg">Action
                                <div class="tooltiptext1 regular fs-14">
                                    <span class="whitespacenormal italic tooltiptext2">Click on the link in the column below to update the document directly. If a broker is no longer with your agency, email join@travelance.ca.</span>
                                </div>   
                            </label>
                            <label *ngIf="showDeactivationColumns" class="tooltip1 mb-0"><img src="./assets/images/iIconblue.svg">Action
                                <div class="tooltiptext1 regular fs-14">
                                    <span class="whitespacenormal italic tooltiptext2">If a broker is no longer with your agency, email join@travelance.ca.</span>
                                </div>   
                            </label>
                        </th>
                        <th>
                            <img src="./assets/images/theadset.png" id="open" (click)="notificationShow()">
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of leads | paginate: { itemsPerPage: showLead, currentPage: p, totalItems: total,id:'paginationNormal'}; let i=index">
                        <td>
                            <label class="container">
                          <input type="checkbox" [checked]="item.isChecked == true" class="form-check-input"  value = true (change)="toggleShowSelected($event,item.id,i,item)">

                          <span class="checkmark"></span>
                            </label>
                        </td>
                        <td><label class="cp outline-0" routerLink="/dashboard/mga-details" (click)="onClickMga($event,item.id,item.mga.id)" *ngIf="showName">{{item.firstName}}</label> </td>
                        <td [ngClass]=" item.stageStatus=='Sign-Up Complete'?'rowbgcolor1':''" *ngIf="showLastName">{{item.lastName}}</td>
                        <td [ngClass]=" item.stageStatus=='Sign-Up Complete'?'rowbgcolor1':''" *ngIf="showStage">{{item.stageStatus}}</td>
                        <td [ngClass]=" item.stageStatus=='Sign-Up Complete'?'rowbgcolor1':''" *ngIf="showType">{{item.type}}</td>
                        <td [ngClass]=" item.stageStatus=='Sign-Up Complete'?'rowbgcolor1':''" *ngIf="showPhone">{{item.workPhone}}</td>
                        <td [ngClass]=" item.stageStatus=='Sign-Up Complete'?'rowbgcolor1':''" *ngIf="showProvinces">{{item.primaryAddressProvince}}</td>
                        <td [ngClass]=" item.stageStatus=='Sign-Up Complete'?'rowbgcolor1':''" *ngIf="showCity">{{item.primaryAddressCity}}</td>
                        <td [ngClass]=" item.stageStatus=='Sign-Up Complete'?'rowbgcolor1':''" [hidden]="showEmail==false">
                            <div *ngFor="let data of item.leadEmails;let isLast=last">
                                <span>{{data.email}}{{isLast ? '' : ', '}}</span>
                            </div>
                        </td>
                        <td [ngClass]=" item.stageStatus=='Sign-Up Complete'?'rowbgcolor1':''" [hidden]="showLanguages==false">
                            <div *ngFor="let data of item.langauges;let isLast=last">
                                <span>{{data}}{{isLast ? '' : ', '}}</span>
                            </div>
                        </td>

                        <td [ngClass]=" item.stageStatus=='Sign-Up Complete'?'rowbgcolor1':''" [hidden]="showStatus==false">{{item.leadStatus}}</td>
                        <td [ngClass]=" item.stageStatus=='Sign-Up Complete'?'rowbgcolor1':''" [hidden]="showSource==false">{{item.leadSource}}</td>
                        <td [ngClass]=" item.stageStatus=='Sign-Up Complete'?'rowbgcolor1':''" [hidden]="showAddress==false">{{item.primaryAddressLine}}</td>
                        <td [ngClass]=" item.stageStatus=='Sign-Up Complete'?'rowbgcolor1':''" [hidden]="showPostal==false">{{item.primaryAddressPostalCode}}</td>
                        <td [ngClass]=" item.stageStatus=='Sign-Up Complete'?'rowbgcolor1':''" [hidden]="showCountry==false">{{item.primaryAddressPostalCountry}}</td>
                        <td [ngClass]=" item.stageStatus=='Sign-Up Complete'?'rowbgcolor1':''" [hidden]="showSelling==false">{{item.productsSelling}}</td>
                        <td [ngClass]=" item.stageStatus=='Sign-Up Complete'?'rowbgcolor1':''" [hidden]="showTitle==false">{{item.positionTitle}}</td>
                        <td [ngClass]=" item.stageStatus=='Sign-Up Complete'?'rowbgcolor1':''" [hidden]="showCIPR==false">{{item.ciprNumber}}</td>
                        <td [ngClass]=" item.stageStatus=='Sign-Up Complete'?'rowbgcolor1':''" [hidden]="showLastTrainingDate==false">{{item.lastTraningDate| date: 'MM/dd/yyyy' || '-'}}</td>
                        <td *ngIf="showDeactivationColumns || showexpDocColumns">
                            <label *ngIf="showexpDocColumns" class="link cp">ON License</label>
                            <label *ngIf="showDeactivationColumns" class="">Documents</label>
                        </td>
                        <td *ngIf="showDeactivationColumns || showexpDocColumns">
                            <label *ngIf="showexpDocColumns" class="yellow cp">02/03/2022</label>
                            <label *ngIf="showDeactivationColumns" class="red cp">02/03/2022</label>
                        </td>
                        <td *ngIf="showDeactivationColumns || showexpDocColumns">
                            <label *ngIf="showexpDocColumns" class=""><u class="link cp">Upload</u> a current copy of this document to the broker’s profile.</label>
                            <label *ngIf="showDeactivationColumns" class="">To reactivate this broker, please contact <a href="mailto:join@travelance.ca">join@travelance.ca</a></label>
                        </td>
                        <td>
                            <span #toggleButton *ngIf="item.stageStatus=='Sign-Up Complete'" [hidden]="item.isDeactivatedByOfficeAdmin == true">
                                <img (click)="resetPayment();check(i)" class="cp" id="openone" src="./assets/images/dots.png">
                            </span>
                        </td>
                        <div id="popupone" *ngIf="isResetOpen && index==i" #menu class="labelbox menu">
                            <label class="fs-14 semi-bold cp m-0" (click)="deActivateBroker(item)">Deactivate</label>
                            <div class="clear5"></div>
                        </div>
                        <!-- <td #toggleButton (click)="toggleMenu();check(id)" class="cp">
                            <img class="cp" id="openone" src="./assets/images/dots.png">

                            <div id="popupone" *ngIf="isMenuOpen && index==id" class="menu labelbox" #menu>
                                <label class="fs-14 semi-bold cp m-0" (click)="toggleShowone(id)">Edit Details</label>

                                <div class="clear5"></div>
                                 <div class="row">
                                    <div class="col-6 col-sm-6 col-md-6 col-lg-6">
                                        <label class="fs-14 semi-bold cp green m-0">Open </label>
                                    </div>
                                    <div class="col-6 col-sm-6 col-md-6 col-lg-6 text-right">
                                        <label class="switch">
                                  <input type="checkbox" checked>
                                  <span class="slider round"></span>
                                </label>
                                    </div>
                                </div> 

                                <div class="clear5"></div>
                                <label class="fs-14 semi-bold cp lightblue">Reset Password
                         </label>
                            </div>
                        </td> -->

                    </tr>
                </tbody>

                <div id="popup" *ngIf="noti" class="notification text-left">
                    <div class="row">
                        <div class="col-6 col-sm-6 col-md-6 col-lg-6">
                            <label class="fs-16 semi-bold black pad20 mb-0">Columns</label>
                        </div>
                        <div class="col-6 col-sm-6 col-md-6 col-lg-6">
                            <button type="button" class="bluebtn fs-16 semi-bold" (click)="notificationShow()">Close</button>
                        </div>
                    </div>
                    <div class="">
                        <label class="container">
                <input type="checkbox" disabled class="form-check-input" [checked]="showName" (change)="showName=!showName" >
                <span class="checkmark"></span>
               </label>
                        <span class="fs-14 regular ml30">First Name</span>
                    </div>
                    <div class="">
                        <label class="container">
                <input type="checkbox" disabled class="form-check-input" [checked]="showLastName" (change)="showLastName=!showLastName">
                <span class="checkmark"></span>
               </label>
                        <span class="fs-14 regular ml30">Last Name</span>
                    </div>
                    <div class="">
                        <label class="container">
                <input type="checkbox" class="form-check-input" [checked]="showStage" (change)="showStage=!showStage">
                <span class="checkmark"></span>
               </label>
                        <span class="fs-14 regular ml30">Stage</span>
                    </div>
                    <!-- <div class="">
                        <label class="container">
                <input type="checkbox" class="form-check-input" [checked]="showType" (change)="showType=!showType">
                <span class="checkmark"></span>
               </label>
                        <span class="fs-14 regular ml30">Type</span>
                    </div> -->
                    <div class="">
                        <label class="container">
                <input type="checkbox" class="form-check-input"  [checked]="showPhone" (change)="showPhone=!showPhone">
                <span class="checkmark"></span>
               </label>
                        <span class="fs-14 regular ml30">Phone No</span>
                    </div>
                    <div class="">
                        <label class="container">
                <input type="checkbox" class="form-check-input" [checked]="showProvinces" (change)="showProvinces=!showProvinces">
                <span class="checkmark"></span>
               </label>
                        <span class="fs-14 regular ml30">Province</span>
                    </div>
                    <div class="">
                        <label class="container">
                <input type="checkbox" class="form-check-input"  [checked]="showCity" (change)="showCity=!showCity">
                <span class="checkmark"></span>
               </label>
                        <span class="fs-14 regular ml30">City</span>
                    </div>
                    <div class="">
                        <label class="container">
                <input type="checkbox" class="form-check-input"  [checked]="showEmail" (change)="showEmail=!showEmail">
                <span class="checkmark"></span>
               </label>
                        <span class="fs-14 regular ml30">Email Address</span>
                    </div>
                    <div class="">
                        <label class="container">
                <input type="checkbox" class="form-check-input"  [checked]="showLanguages" (change)="showLanguages=!showLanguages">
                <span class="checkmark"></span>
               </label>
                        <span class="fs-14 regular ml30">Languages</span>
                    </div>
                    <!-- <div class="">
                        <label class="container">
                <input type="checkbox" class="form-check-input"  [checked]="showStatus" (change)="showStatus=!showStatus">
                <span class="checkmark"></span>
               </label>
                        <span class="fs-14 regular ml30">Lead Status</span>
                    </div> -->
                    <!-- <div class="">
                        <label class="container">
                <input type="checkbox" class="form-check-input"  [checked]="showSource" (change)="showSource=!showSource">
                <span class="checkmark"></span>
               </label>
                        <span class="fs-14 regular ml30">Lead Source</span>
                    </div> -->
                    <div class="">
                        <label class="container">
                <input type="checkbox" class="form-check-input"  [checked]="showAddress" (change)="showAddress=!showAddress">
                <span class="checkmark"></span>
               </label>
                        <span class="fs-14 regular ml30">Primary Address</span>
                    </div>
                    <!-- <div class="">
                        <label class="container">
                <input type="checkbox" class="form-check-input"  [checked]="showPostal" (change)="showPostal=!showPostal">
                <span class="checkmark"></span>
               </label>
                        <span class="fs-14 regular ml30">Postal Address</span>
                    </div> -->
                    <!-- <div class="">
                        <label class="container">
                <input type="checkbox" class="form-check-input"  [checked]="showCountry" (change)="showCountry=!showCountry">
                <span class="checkmark"></span>
               </label>
                        <span class="fs-14 regular ml30">Primary Country</span>
                    </div> -->
                    <!-- <div class="">
                        <label class="container">
                <input type="checkbox" class="form-check-input"  [checked]="showSelling" (change)="showSelling=!showSelling">
                <span class="checkmark"></span>
               </label>
                        <span class="fs-14 regular ml30">Product Selling</span>
                    </div> -->
                    <!-- <div class="">
                        <label class="container">
                <input type="checkbox" class="form-check-input"  [checked]="showTitle" (change)="showTitle=!showTitle">
                <span class="checkmark"></span>
               </label>
                        <span class="fs-14 regular ml30">positionTitle</span>
                    </div> -->
                    <div class="">
                        <label class="container">
                <input type="checkbox" class="form-check-input"  [checked]="showLastTrainingDate" (change)="showLastTrainingDate=!showLastTrainingDate">
                <span class="checkmark"></span>
               </label>
                        <span class="fs-14 regular ml30">Last Training Date</span>
                    </div>
                </div>
            </table>
            <pagination-controls (pageChange)="p = $event" [id]="paginationconfigNormal.id" (click)="pageChnageDone(p)" class="float-right"></pagination-controls>
        </div>
    </div>
    <div class="row" *ngIf="showActivatedTable">
        <div class="table-responsive">
            <!-- Toggle column: <a class="toggle-vis" data-column="1">First Name</a> - <a class="toggle-vis" data-column="2">Last Name</a> - <a class="toggle-vis" data-column="3">Stage</a> - <a class="toggle-vis" data-column="4">Type</a> - <a class="toggle-vis" data-column="5">Phone No</a> - <a class="toggle-vis" data-column="6">Provinces</a>- <a class="toggle-vis" data-column="7">City </a> -->
            <!-- <div class="dataTables_length" id="agency-table_length"><label>Show <select name="agency-table_length" aria-controls="agency-table" class=""><option value="10">10</option><option value="25">25</option><option value="50">50</option><option value="100">100</option></select> entries</label></div> -->
            <table id="lead-table1" class="display table tablepos">

                <thead class="nowrap">
                    <tr>
                        <th>
                            <label class="container pb10">
                       <input type="checkbox" class="form-check-input" [checked]="selectAllCheckbox==true" value = true (change)="toggleShow($event)">
                       <span class="checkmark"></span>
                      </label>
                        </th>
                        <th [hidden]="showName==false">                       
                                <div class="d-flex flex-row align-items-center">
                                    <span>First Name</span>
                                    <div class="d-flex flex-column ml-2">
                                        <i *ngIf="!moreInfoReqiredColumns" class="fa fa-caret-up" (click)="onSort1('lead')"></i>
                                        <i *ngIf="!moreInfoReqiredColumns" class="fa fa-caret-down" (click)="onSortdesc1('lead')"></i>
                                        <i *ngIf="moreInfoReqiredColumns" class="fa fa-caret-up" (click)="onSort2('lead')"></i>
                                        <i *ngIf="moreInfoReqiredColumns" class="fa fa-caret-down" (click)="onSortdesc2('lead')"></i>
                                    </div>
                                </div>
                        </th>
                        <th [hidden]="showLastName==false">
                            <div class="d-flex flex-row align-items-center">
                                <span>Last Name</span>
                                <div class="d-flex flex-column ml-2">
                                    <i  *ngIf="!moreInfoReqiredColumns" class="fa fa-caret-up" (click)="onSort1('lead')"></i>
                                    <i  *ngIf="!moreInfoReqiredColumns" class="fa fa-caret-down" (click)="onSortdesc1('lead')"></i>
                                    <i *ngIf="moreInfoReqiredColumns" class="fa fa-caret-up" (click)="onSort2('lead')"></i>
                                    <i *ngIf="moreInfoReqiredColumns" class="fa fa-caret-down" (click)="onSortdesc2('lead')"></i>
                                </div>
                            </div>
                        </th>
                       
                        <!-- <th *ngIf="showexpDocColumns || showDeactivationColumns || moreInfoReqiredColumns">
                            <label *ngIf="showexpDocColumns || moreInfoReqiredColumns" class="tooltip1 mb-0 displayInline"><img src="./assets/images/iIconblue.svg">
                                <div class="d-flex flex-row align-items-center">
                                    <span>Document</span>
                                    <div class="d-flex flex-column ml-2">
                                        <i *ngIf="!moreInfoReqiredColumns" class="fa fa-caret-up" (click)="onSort1('docProvince')"></i>
                                        <i *ngIf="!moreInfoReqiredColumns" class="fa fa-caret-down" (click)="onSortdesc1('docProvince')"></i>
                                        <i *ngIf="moreInfoReqiredColumns" class="fa fa-caret-up" (click)="onSort2('docProvince')"></i>
                                        <i *ngIf="moreInfoReqiredColumns" class="fa fa-caret-down" (click)="onSortdesc2('docProvince')"></i>
                                    </div>
                                </div>
                            <div class="tooltiptext1 regular fs-14">
                                <span class="whitespacenormal italic tooltiptext2">Click on the link in the column below to review the broker's document and profile.</span>
                            </div>   
                            </label>
                            <label *ngIf="showDeactivationColumns" class="mb-0">Reason for Deactivation</label>                    
                        </th> -->
                        <th *ngIf="showexpDocColumns || showDeactivationColumns || moreInfoReqiredColumns">
                            <label *ngIf="showexpDocColumns || moreInfoReqiredColumns" class="tooltip1 mb-0 displayInline"><img src="./assets/images/iIconblue.svg">
                                <div class="d-flex flex-row align-items-center">
                                    <span>Expiry Date</span>
                                    <div class="d-flex flex-column ml-2">
                                        <i *ngIf="!moreInfoReqiredColumns" class="fa fa-caret-up" (click)="onSort1('expiryDate')"></i>
                                        <i *ngIf="!moreInfoReqiredColumns" class="fa fa-caret-down" (click)="onSortdesc1('expiryDate')"></i>
                                        <i *ngIf="moreInfoReqiredColumns" class="fa fa-caret-up" (click)="onSort2('expiryDate')"></i>
                                        <i *ngIf="moreInfoReqiredColumns" class="fa fa-caret-down" (click)="onSortdesc2('expiryDate')"></i>
                                    </div>
                                </div>
                                <div class="tooltiptext1 regular fs-14">
                                    <span class="whitespacenormal italic tooltiptext2">Yellow indicates the document will expire within 30 days. Red indicates the document has expired.</span>
                                </div>   
                            </label>
                            <label *ngIf="showDeactivationColumns" class="tooltip1 mb-0"><img src="./assets/images/iIconblue.svg">Date Deactivated
                                <div class="tooltiptext1 regular fs-14">
                                    <span class="whitespacenormal italic tooltiptext2">This is the date the broker was deactivated for sales in all provinces.</span>
                                </div>   
                            </label>
                        </th>
                        <th [hidden]="isDeactivate==true">
                            <div class="d-flex flex-row align-items-center">
                                <span>Status</span>
                                <div class="d-flex flex-column ml-2">
                                    <i *ngIf="!moreInfoReqiredColumns" class="fa fa-caret-up" (click)="onSort1('status')"></i>
                                    <i *ngIf="!moreInfoReqiredColumns" class="fa fa-caret-down" (click)="onSortdesc1('status')"></i>
                                    <i *ngIf="moreInfoReqiredColumns" class="fa fa-caret-up" (click)="onSort2('status')"></i>
                                    <i *ngIf="moreInfoReqiredColumns" class="fa fa-caret-down" (click)="onSortdesc2('status')"></i>
                                </div>
                            </div>
                        </th>
                        <th *ngIf="showDeactivationColumns || showexpDocColumns || moreInfoReqiredColumns">
                            <label *ngIf="showexpDocColumns || moreInfoReqiredColumns" class="tooltip1 mb-0"><img src="./assets/images/iIconblue.svg">Action
                                <div class="tooltiptext1 regular fs-14">
                                    <span class="whitespacenormal italic tooltiptext2">Click on the link in the column below to update the document directly. If a broker is no longer with your agency, email join@travelance.ca.</span>
                                </div>   
                            </label>
                            <label *ngIf="showDeactivationColumns" class="tooltip1 mb-0"><img src="./assets/images/iIconblue.svg">Action
                                <div class="tooltiptext1 regular fs-14">
                                    <span class="whitespacenormal italic tooltiptext2">If a broker is no longer with your agency, email join@travelance.ca.</span>
                                </div>   
                            </label>
                        </th>
                       
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of leadsActivate | paginate: { itemsPerPage: showLeadActivate, currentPage: p, totalItems: totalActivate, id: 'paginationActivate'}; let i=index">
                        <td>
                            <label class="container">
                          <input type="checkbox" [checked]="item.isChecked == true" class="form-check-input"  value = true (change)="toggleShowSelected($event,item.id,i,item)">

                          <span class="checkmark"></span>
                            </label>
                        </td>
                        <td>
                            <label class="cp outline-0" routerLink="/dashboard/mga-details" (click)="onClickMga1($event,item.lead.id)" *ngIf="this.isDeactivate==false && item.lead != null">{{item.lead.firstName}}</label> 
                            <label class="cp outline-0" routerLink="/dashboard/mga-details" (click)="onClickMgaDeactivate($event,item.id)" *ngIf="this.isDeactivate==true">{{item.firstName}}</label> 
                        </td>
                        <td [ngClass]=" item.stageStatus=='Sign-Up Complete'?'rowbgcolor1':''" >
                            <label *ngIf="this.isDeactivate==false && item.lead != null">{{item.lead.lastName}}</label>
                            <label *ngIf="this.isDeactivate==true">{{item.lastName}}</label>
                        </td>
                        
                        <!-- <td *ngIf="showDeactivationColumns || showexpDocColumns || moreInfoReqiredColumns">
                            <label *ngIf="showexpDocColumns && item.docProvince != null" class="link cp"  routerLink="/dashboard/mga-details" (click)="onDocd(item.lead.id)">{{item.docProvince}} {{item.documentTypeName}}</label>
                            <label *ngIf="showexpDocColumns && item.docProvince == null" class="link cp"  routerLink="/dashboard/mga-details" (click)="onDocd(item.lead.id)">{{item.documentTypeName}}</label>
                            <label *ngIf="moreInfoReqiredColumns && item.docProvince != null" class="link cp"  routerLink="/dashboard/mga-details" (click)="onDocd(item.lead.id)">{{item.docProvince}} {{item.documentTypeName}}</label>
                            <label *ngIf="moreInfoReqiredColumns && item.docProvince == null" class="link cp"  routerLink="/dashboard/mga-details" (click)="onDocd(item.lead.id)">{{item.documentTypeName}}</label>
                            <label *ngIf="showDeactivationColumns" class="">Document</label>
                        </td> -->
                        <td *ngIf="showDeactivationColumns || showexpDocColumns || moreInfoReqiredColumns">
                            <label *ngIf="showexpDocColumns" [ngClass]="{'expiring': item.expiring==true,'expired': item.expired==true}">{{item.expiryDate | date: 'MM/dd/yyyy'}}</label>
                            <label *ngIf="moreInfoReqiredColumns" [ngClass]="{'expiring': item.expiring==true,'expired': item.expired==true}">{{item.expiryDate | date: 'MM/dd/yyyy'}}</label>
                            <label *ngIf="showDeactivationColumns" class="red">{{item.dateDeactivated | date: 'MM/dd/yyyy'}}</label>
                        </td>
                        <td [hidden]="isDeactivate==true">
                            <label>{{item.status}}</label>
                            <div class="row" *ngIf="item.status == 'Not Approved' || item.status == ''|| item.status == 'More Information Required'">
                                <h3 class="fs-14 red regular">Action:'{{item.description}}'</h3>
                            </div>
                        </td>
                        <td *ngIf="showDeactivationColumns || showexpDocColumns || moreInfoReqiredColumns">
                            <label *ngIf="showexpDocColumns && item.docProvince != null" class="" (click)="docIdLicens(item.id,item.fileId,item.expiryDate,item.docNumber,item.type,item.docProvince,item.docName,item.lead.id)"><u class="link cp">Upload</u> a current copy of this document to the broker’s profile.</label>
                            <label *ngIf="showexpDocColumns && item.docProvince == null" class="" (click)="docIdEno(item.id,item.fileId,item.docName,item.docNumber,item.expiryDate,item.lead.id)"><u class="link cp">Upload</u> a current copy of this document to the broker’s profile.</label>
                            <label *ngIf="moreInfoReqiredColumns && item.docProvince != null" class="" (click)="docIdLicens(item.id,item.fileId,item.expiryDate,item.docNumber,item.type,item.docProvince,item.docName,item.lead.id)"><u class="link cp">Upload</u> a current copy of this document to the broker’s profile.</label>
                            <label *ngIf="moreInfoReqiredColumns && item.docProvince == null" class="" (click)="docIdEno(item.id,item.fileId,item.docName,item.docNumber,item.expiryDate,item.lead.id)"><u class="link cp">Upload</u> a current copy of this document to the broker’s profile.</label>
                            <label *ngIf="showDeactivationColumns" class="">To reactivate this broker, please contact <a href="mailto:join@travelance.ca">join@travelance.ca</a></label>
                        </td>
                      

                    </tr>
                </tbody>              
            </table>
            <pagination-controls (pageChange)="p = $event" [id]="paginationconfigActivate.id" (click)="pageChnageDone(p)" class="float-right"></pagination-controls>
        </div>
    </div>
</div>
<div id="uploadLicensePopup" class="modal" [style.display]="uploadnewLicensePopup ? 'block' : 'none'">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-body">
                <h6 class="fs-18 txt-black regular">Upload License<span class="close1 float-right cp" (click)=" this.uploadnewLicensePopup = !this.uploadnewLicensePopup">&times;</span></h6>
                <div class="clear10"></div>
                <p class="regular fs-14 txt-grey1">Please select .pdf, .png, .jpeg or .docx file only</p>
                <div class="clear20"></div>
                <div class="row">
                    
                    <div class="col-sm-8 col-md-8 col-lg-4 col-xl-4 col-12 pr-2">
                        <label class="fs-14 regular">Choose File</label>
                        <div class="uploadfile1">
                            <input type="file" [(ngModel)]="filelicens" (change)="FileSelectLic($event)">
                            <button type="button" class="btn file-btn1">Choose File</button>
                        </div>
                        <span class="error-msg red fs-14">
                            </span>
                        <label class="fs-16 normal" [ngClass]="fileExtensionErrorMsg ?'red':''">{{fileenoNameLic}}</label>
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 pr-2">
                        
                            <div class="form-group">
                                <!-- <select class="form-control selectinput mt-2" [(ngModel)]="uploadlic.province">
                                        <option selected disabled>Select province</option>
                                        <option disabled hidden value="undefined">Select province</option>
                                        <option *ngFor="let item of provienceList" [value]="item.provinceCode">
                                            {{item.provinceName}}- {{item.provinceCode}}</option>
                                    </select> -->
                                <!-- <span class="error-msg red fs-14" *ngIf="showlicpErrorMsgone"></span> -->
                                <label class="fs-14 regular">Select province</label>
                                <select class="form-control forminput" [(ngModel)]="province" placeholder="Add province">
                                    <option [value]="undefined"disabled>Select province</option>
                                    <!-- <option disabled hidden value="undefined">Select province</option> -->
                                    <option *ngFor="let item of provinceData" [value]="item.provinceCode">
                                        {{item.provinceName}}- {{item.provinceCode}}</option>
                                </select>
                                <span class="error-msg red fs-14" *ngIf="showlicpErrorMsgone">
                                </span>
                            </div>
                        
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 pr-2">
                        <div class="form-group">
                            <label class="fs-14 regular">License Type</label>
                            <select class="form-control forminput" [(ngModel)]="licencesType" placeholder="License Type">
                                    <!-- <option selected disabled>Select province</option> -->
                                    <option [value]="undefined" disabled>License Type</option>
                                    <option *ngFor="let item of licencesTypes" [value]="item">
                                        {{item}}</option>
                                </select>
                            <span class="error-msg red fs-14" *ngIf="showlictErrorMsgone"></span>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 pr-2">
                        <div class="form-group ">
                            <label class="fs-14 regular">License Number</label>
                            <input type="text" class="form-control forminput h33" placeholder="Enter License Number" maxlength="30" [(ngModel)]="licenseNumber">
                        </div>
                        <span class="error-msg red fs-14" *ngIf="showlicnErrorMsgone">
                        </span>
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 pr-2">
                        <label class="fs-14 regular">Effective Date</label>
                        <input class="form-control forminput h33" placeholder="MM-DD-YYYY" [owlDateTimeTrigger]="dt18" [owlDateTime]="dt18" [max]="expiryDateLic1" [(ngModel)]="effectiveDateLic1">
                        <span class="trigger" [owlDateTimeTrigger]="dt18">
                           </span>
                           <span class="error-msg red fs-14" *ngIf="showlicdErrorMsgone"></span>
                        <owl-date-time [pickerType]="'calendar'" #dt19></owl-date-time>
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 pr-2">
                        <label class="fs-14 regular">Expiry Date</label>
                        <input class="form-control forminput h33" placeholder="MM-DD-YYYY" [owlDateTimeTrigger]="dt19" [owlDateTime]="dt19" [min]="minDate" [(ngModel)]="expiryDateLic1">
                        <span class="trigger" [owlDateTimeTrigger]="dt19">
                           </span>
                           <span class="error-msg red fs-14" *ngIf="showlicdErrorMsgone"></span>
                        <owl-date-time [pickerType]="'calendar'" #dt19></owl-date-time>
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 pr-2">
                        <button type="button" class="btn btn-upload" (click)="uploadlicensefile(expiryDateLic1,effectiveDateLic1,filelicens,licenseNumber,licencesType,province)">Upload</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="clear20"></div>
</div>
<div id="uploadLicensePopup" class="modal" [style.display]="uploadExpEOPopup ? 'block' : 'none'">
    <!-- Modal content -->
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-body">
                <h6 class="fs-18 txt-black regular">Upload E&O<span class="close1 float-right cp" (click)=" this.uploadExpEOPopup = !this.uploadExpEOPopup;">&times;</span></h6>           
                <div class="clear10"></div>
                <p class="regular fs-14 txt-grey1">Please select .pdf, .png, .jpeg or .docx file only</p>
                <div class="clear20"></div>
                <div class="row">
                    <div class="col-sm-8 col-md-8 col-lg-4 col-xl-4 col-12 pr-2">
                        <label class="fs-14 regular">Choose File</label>
                        <div class="uploadfile1">
                            <input type="file" (change)="FileSelect($event)" maxFileSize="50000" [(ngModel)]="fileeno">
                            <button type="button" class="btn file-btn1">Choose File</button>
                        </div>
                        <span class="error-msg red fs-14" *ngIf="showemailErrorMsg"></span>
                        <label class="fs-16 normal " [ngClass]="showemailErrorMsg ?'red':''">
                            {{fileenoName}}</label>
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 pr-2">
                        <div class="form-group ">
                            <label class="fs-14 regular">E&O Policy Number</label>
                            <input type="text" class="form-control forminput w95" placeholder="E&O Policy Number" [(ngModel)]="policyNumber">
                        </div>
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 pr-2">
                        <div class="form-group">
                            <label class="fs-14 regular">Effective Date</label>
                            <input class="dis-inb form-control forminput mr-1" placeholder="MM-DD-YYYY" [owlDateTimeTrigger]="dt18" [owlDateTime]="dt18" [max]="eoexpiryDate1" [(ngModel)]="eoeffectiveDate1">
                            <span class="trigger" [owlDateTimeTrigger]="dt18">
                               </span>
                            <span class="error-msg red fs-14"></span>
                            <owl-date-time [pickerType]="'calendar'" #dt18></owl-date-time>
                        </div>
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 pr-2">
                        <div class="form-group">
                            <label class="fs-14 regular">Expiry Date</label>
                            <input class="dis-inb form-control forminput mr-1" placeholder="MM-DD-YYYY" [owlDateTimeTrigger]="dt19" [owlDateTime]="dt19" [min]="minDate" [(ngModel)]="eoexpiryDate1">
                            <span class="trigger" [owlDateTimeTrigger]="dt19">
                               </span>
                            <span class="error-msg red fs-14"></span>
                            <owl-date-time [pickerType]="'calendar'" #dt19></owl-date-time>
                        </div>
                    </div>
                </div>
                <div class="clear20"></div>
                <div class="row">
                    <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                        <button type="button" class="btn btn-upload" (click)="uploadEno()">Update</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div id="agentcodedataid" class="modal" [style.display]="drop ? 'block' : 'none'">
    <!-- Modal content -->
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-body">
               
                <div class="clear10"></div>
                <div class="card upload-card card1" *ngFor="let item of agentcodedata1">
                    <div class="row">
                        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12">
                            <h6 class="fs-18 txt-black ml-2 mt-2 regular">Agency Code:&nbsp;&nbsp;&nbsp;{{item.agentCode}}<span class="close1 float-right mr-2 mt-2 cp" (click)="close1()">&times;</span></h6>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            
                            <div class="col-sm-12 col-md-12 col-lg-7 col-xl-7 col-12">
                                <button type="button" class="getReliablebtn1 regular olnone cp" (click)="goToGetReliable()">
                                    <!-- <span class="flot-left ml-2">VTC/TRIPs/SAP Sales</span> -->
                                    <label class="flot-left mb-0 fs-18 cp">VTC/TRIPs/SAP Sales
                                        <span class="tooltip2">
                                            <img src="./assets/images/iIconblue.svg">
                                            <div class="tooltiptext2 regular fs-14">
                                            <span class="whitespacenormal italic">Select this option for Visitors to Canada, Student Accident, and Travel Right Insurance Plans.</span>
                                            </div>
                                        </span>
                                    </label>
                                    <img class="float-right mt-1 ml-3" src="./assets/images/forwararrow.png">
                                </button>
                                
                            </div>
                        </div>
                        <div class="clear15"></div>
                        <div class="row mt-3">
                            <div class="col-sm-3 col-md-2 col-lg-2 col-xl-2 col-4 ">
                                <span class="fs-16  lablecolor">User ID:</span>
                            </div>
                            <div class="col-sm-9 col-md-9 col-lg-9 col-xl-9 col-8">
                                <h6 class="fs-15 txt-black bold regular ml-4 mt-1">{{item.agentUserId}}</h6>
                            </div>
                        </div>
                        <div class="clear15"></div>
                        <div class="row mt-3">
                            <div class="col-sm-3 col-md-2 col-lg-2 col-xl-2 col-4 ">
                                <span class="fs-16  lablecolor">Password:</span>
                            </div>
                            <div class="col-sm-9 col-md-9 col-lg-9 col-xl-9 col-8">

                                <h6 class="fs-15 txt-black bold regular ml-4 mt-1">{{item.password}}</h6>
                                <div class="clear10"></div>
                                <h6 class="fs-15 txt-black regular ml-4 mt-1">As shown in your "Welcome to Travelance! Online Portal Login and Orientation" email or as changed by you in the online sales portal.</h6>
                            </div>
                        </div>
                        <div class="clear15"></div>
                        <div class="row" *ngIf="item.b2cLink!=null && mgaName!='World Financial Group (MGA)'">
                            <div class="col-sm-3 col-md-2 col-lg-2 col-xl-2 col-4 text-right">
                                <span class="fs-16 bold lablecolor">B2C Link:</span>
                            </div>
                            <div class="col-sm-9 col-md-9 col-lg-9 col-xl-9 col-8">
                                <h6 class="fs-15 regular ml-4 mt-1"><a href="{{item.b2cLink}}" target="_blank">{{item.b2cLink}}</a></h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div id="uploadAddleadPopup" class="modal pad23" [style.display]="showAddAgent ? 'block' : 'none'">
    <!-- Modal content -->
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-body">
                <h6 class="fs-18 txt-black regular">Add Agent<span class="close1 float-right cp" (click)=" this.showAddAgent = !this.showAddAgent;closeAgentPopup()">&times;</span></h6>           
                <div class="row">
                    <div class="col-sm-4 col-md-6 col-lg-6 col-xl-6 col-12 pr-2">
                        <div class="form-group ">
                            <label class="fs-14 regular">First Name<span class="txt-red1 fs-18">*</span></label>
                            <input type="text" class="form-control forminput w95" placeholder="First Name" [(ngModel)]="firstName">
                        </div>
                    </div>
                    <div class="col-sm-4 col-md-6 col-lg-6 col-xl-6 col-12 pr-2">
                        <div class="form-group ">
                            <label class="fs-14 regular">Last Name<span class="txt-red1 fs-18">*</span></label>
                            <input type="text" class="form-control forminput w95" placeholder="Last Name" [(ngModel)]="lastName">
                        </div>
                    </div>
                    <div class="col-sm-4 col-md-6 col-lg-6 col-xl-6 col-12 pr-2">
                        <div class="form-group ">
                            <label class="fs-14 regular">Email Address<span class="txt-red1 fs-18">*</span></label>
                            <div *ngFor="let row of leadEmailAddress;let i=index; let last = last">
                                <div>
                                    <input [(ngModel)]="row.email"
                                        (input)="checkEmail(i,row);emailCheck(row.email,row);leadEmailAddressErrMsgred();checkConfirmEmail()" type="text"
                                        class="form-control forminput w95" placeholder="Enter here">
                                 <div class="w95 ml-2 red fs-12" *ngIf="row.error3" [innerHTML]="row.error3"></div>
                                    <div class="w95 ml-2 red fs-12" *ngIf="row.error5">
                                        {{row.error5}}
                                    </div>
                                    <div class="w95 ml-2 red fs-12" *ngIf="row.error6">
                                        {{row.error6}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-4 col-md-6 col-lg-6 col-xl-6 col-12 pr-2">
                        <div class="form-group ">
                            <label class="fs-14 regular">Confirm Email Address<span class="txt-red1 fs-18">*</span></label>
                            <div>
                                <input type="text" class="form-control forminput w95" placeholder="Confirm Email Address" [(ngModel)]="purchaseEmailConfirm" (input)="checkConfirmEmail(); onConfirmEmailClick()" maxlength="128">
                                <p class="fs-14 regular red" *ngIf="confirmEmailMatch">Email and Confirm Email Address does not match.</p>
                                <p class="fs-14 regular red"  *ngIf="purchaseConfirmEmailFlag">'Confirm Email Address' is required.</p>
                            </div>
                              </div>
                    </div>
                    <div class="col-sm-4 col-md-6 col-lg-6 col-xl-6 col-12 pr-2">
                        <div class="form-group ">
                            <label class="fs-14 regular">Work Phone<span class="txt-red1 fs-18">*</span></label>
                            <input type="tel" onkeydown="if(event.key==='.'){event.preventDefault();}"  oninput="event.target.value = event.target.value.replace(/[^[0-9()\-]+$]*/g,'');"  class="form-control forminput w95" placeholder="Work Phone" [(ngModel)]="workPhone" (input)="checkPhone();checkPatternWork(workPhone)" maxlength="15">
                            <div class="w95 ml-2 red fs-12" *ngIf="error1">
                                            {{error1}}
                                        </div>
                                        <div class="w95 ml-2 red fs-12" *ngIf="error9">
                                            {{error9}}
                                        </div>
                        </div>
                    </div>
                    <div class="col-sm-4 col-md-6 col-lg-6 col-xl-6 col-12 pr-2">
                        <div class="form-group "  style="position: relative;">
                                <label class="fs-14 regular">Street Address<span class="txt-red1 fs-18">*</span></label>
                            
                            
                                <input id="cap" type="text" [(ngModel)]="primaryCompleteAddress" autocomplete="off" (input)="callAddressApiCall()"
                                    class="form-control forminput w95"
                                    placeholder="Primary Street Address">
                                <div class="searchResultBox" *ngIf="showAddressResults1">
                                    <h6 class="close1 text-right mt-1 mr-1"
                                        (click)=" this.showAddressResults1 = !this.showAddressResults1;">&times;</h6>
                                    <div class="borderbottom">
                                    </div>
                                    <div class="row borderbottom p-1" *ngFor="let item of getPrimaryAddress">
                                        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                            <label class="fs-14 regular m-0 link cp"
                                                (click)="onClickSearchResultprimary(item)">{{item.place_name}}</label><br>
                                        </div>
                                    </div>
                                </div>
                        </div>
                    </div>
                    <div class="col-sm-4 col-md-6 col-lg-6 col-xl-6 col-12 pr-2">
                        <div class="form-group ">
                                <label class="fs-14 regular">City<span class="txt-red1 fs-18">*</span></label>
                                <input id="cap" type="text" [(ngModel)]="primaryAddressCity"
                                    class="form-control forminput w95"
                                    placeholder="Primary Address City" >
                        </div>
                    </div>
                    <div class="col-sm-4 col-md-6 col-lg-6 col-xl-6 col-12 pr-2">
                        <div class="form-group ">
                            
                                <label class="fs-14 regular">Province<span class="txt-red1 fs-18">*</span></label>
                            
                            
                                <ng-select [(ngModel)]="primaryAddressProvince"
                                    class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12 Tab w95" placeholder="Select Province">
                                    <ng-option [value]="item.provinceCode"
                                        *ngFor="let item of provinceData">{{item.provinceName}}-{{item.provinceCode}}</ng-option>
                                </ng-select>
                           
                        </div>
                    </div>
                    <div class="col-sm-4 col-md-6 col-lg-6 col-xl-6 col-12 pr-2">
                        <div class="form-group ">
                           
                                <label
                                    class="fs-14 regular">Postal
                                    Code<span class="txt-red1 fs-18">*</span></label>
                           
                            
                                <input type="text" [(ngModel)]="primaryAddressPostalCode" (input)="ip(primaryAddressPostalCode)"
                                    class="form-control forminput w95"
                                    placeholder="Primary Postal Code" maxlength="7">
                            <p class="fs-14 regular red" *ngIf="ErrorMsgten">Postal Code is not valid.</p>
                        </div>
                    </div>
                
                </div>
                <div class="row">
                    <div class="col-sm-8 col-md-8 col-lg-8 col-xl-8 col-12">

                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                        <button type="button" class="btn btn-upload" (click)="onClickSaveAndSendAgent()">Save and Send</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>